import angular from 'angular';
import uiRouter from 'angular-ui-router';
import AppCore from '../../core';
import { TableroEspecialistasComponent, translationKeys } from './tablero.component';

export * from './tablero.component';

export default angular.module('spa.tablero-especialistas', [
  'ui',
  'spa.i18n',
  AppCore,
  uiRouter
])
  .config(config)
  .component(TableroEspecialistasComponent.selector, TableroEspecialistasComponent)
  .name;

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider
    .state('tablero-especialistas', {
      url: '/tablero-especialistas',
      template: '<tablero-especialistas translations="$resolve.translations"></tablero-especialistas>',
      resolve: {
        translations
      },
      access: {
        requiresLogin: true
      },
      ncyBreadcrumb: {
        skip: true
      }
    });
}

translations.$inject = ['LangService'];

function translations(LangService) {
  return LangService.getTranslations(translationKeys);
}


// WEBPACK FOOTER //
// ./src/components/tablero-especialistas/index.js